<template>
    <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="w-100">
            <h5>{{title}}<button type="button" class="close"
                                 @click.prevent="closeModal()">
                <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
        <b-form>
            <div class="container-fluid visit-charge-body">
                <div class="row justify-content-center m-2">
                    <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
                        <div>{{ generalErrorMessage }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2">
                    </div>
                    <div class="col-8">
                        <b-form-group :label-cols="4"
                                      label="Notification"
                                      :state="stateForField('notificationId')"
                                      :invalid-feedback="errorForField('notificationId')"
                                      label-class="text-right">
                            <b-dropdown menu-class="dropdown-container" :text="notificationName" :variant="hasError('notificationId') ? 'outline-danger' : 'outline-dark'">
                                <b-dropdown-item v-for="notification in notifications" :key="notification.organizationCustomNotificationId"
                                                 @click.prevent="setNotification(notification)">{{ notification.name }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-form-group>
                        <b-form-group :label-cols="4"
                                      label="Preview"
                                      label-class="text-right">
                            <b-textarea v-model="notificationPreview" readonly></b-textarea>
                        </b-form-group>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="save()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Send</button>
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
  import api from '../services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin.js'

  export default {
    name: 'SendCustomNotification',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      visitId: {
        type: Number,
        required: true
      },

      title: {
        type: String,
        default: 'Send Message'
      }
    },

    data () {
      return {
        notifications: [],
        notificationId: 0,
        isSaving: false,
        notificationName: 'Click to select',
        notificationPreview: ''
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue) {
          this.clearData()
        }
      },

      visitId (newValue, oldValue) {
        if (oldValue !== newValue && newValue) {
          this.clearData()
        }
      }
    },

    computed: {
    },

    methods: {
      clearData () {
        this.clearAllErrors()
        this.notificationId = 0
        this.notifications = []
        this.notificationName = 'Click to select'
        this.notificationPreview = ''
        this.loadData()
      },

      validate () {
        this.clearAllErrors()

        if (!this.notificationId > 0) {
          this.addErrorForField('notificationId', 'You must select a notification')
        }

        return !this.hasErrors()
      },

      setNotification (notification) {
        this.notificationId = notification.organizationCustomNotificationId
        this.notificationName = notification.name
        this.notificationPreview = notification.preview
      },

      loadData () {

        api.get('/Dashboard/Visit/' + this.visitId + '/CustomNotifications').then(response => {
          // filter out payment templates
          this.notifications = []
          for (let i = 0; i < response.data.length; i++) {
            const current = response.data[i]
            if (current.notificationType === 17 || current.notificationType === 18) {
              continue
            }
            this.notifications.push(current)
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load notifications: ' + error.message, error)
          }
        })
      },

      save () {
        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.isSaving = true
        api.post('/Dashboard/SendCustomNotificationSms/' + this.visitId + '/' + this.notificationId).then(response => {
          this.$emit('notificationSent', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to send notification: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>
    .visit-charge-body {
        font-size: 16px;
    }

    .current-charge .fa-trash-alt {
        cursor: pointer;
    }

    .current-charge .fa-trash-alt:HOVER {
        color: rgb(255, 70, 0);
    }

</style>
